import { UnitSystem } from '../../shared/enums/unit-system.enum';
import { REGEXP_PATTERNS } from '../../shared/consts/regexp-patterns';

export const ADVANCEDPIPE_MAX_MIN_VALIDATORS = {
    // PIPE section
    OUTSIDE_DIAMETER_MIN: { USC: 2.375, SI: 60.32 }, // 2.375 to 24in - SI rounded to 2 decimals (60.325 → 60.32)
    OUTSIDE_DIAMETER_MAX: { USC: 24, SI: 609.6 },
    WALL_THICKNESS_MIN: { USC: 0.190, SI: 4.83 }, // 0.190 to 1.5in - SI rounded to 2 decimals  
    WALL_THICKNESS_MAX: { USC: 1.5, SI: 38.1 },
    PIPE_WT_REDUCTION_MIN: 87.5, // 87.5 to 100%
    PIPE_WT_REDUCTION_MAX: 100,
    
    // MATERIAL section  
    MAX_FLAW_SIZE_MIN: { USC: 0, SI: 0 },
    MAX_FLAW_SIZE_MAX: { USC: 0.25, SI: 6.35 },
    MATERIAL_TOUGHNESS_MIN: { USC: 1, SI: 1 }, 
    MATERIAL_TOUGHNESS_MAX: { USC: 2, SI: 2 },
    OVALITY_MIN: 0, 
    OVALITY_MAX: 1,
    ECCENTRICITY_MIN: 0, 
    ECCENTRICITY_MAX: 25,
    POISSON_MIN: 0.27, 
    POISSON_MAX: 0.33,
    RESIDUAL_STRESS_MIN: { USC: -0.5, SI: -0.5 }, 
    RESIDUAL_STRESS_MAX: { USC: 0.5, SI: 0.5 },
    SMYS_MIN: { USC: 35, SI: 241.3 }, 
    SMYS_MAX: { USC: 150, SI: 1034.2 },
    UTS_MIN: { USC: 40, SI: 275.8 }, 
    UTS_MAX: { USC: 160, SI: 1103.2 }, 
    YOUNG_MODULUS_MIN: { USC: 25000, SI: 172369 }, // Young's Modulus: 25000-30000 ksi
    YOUNG_MODULUS_MAX: { USC: 30000, SI: 206843 },
    
    // LOADS section
    INTERNAL_PRESSURE_MIN: { USC: 0, SI: 0 }, // Internal Pressure: >= 0 ksi
    EXTERNAL_PRESSURE_MIN: { USC: 0, SI: 0 } // External Pressure: >= 0 ksi = 0 MPa (conversión exacta)
};

export const ADVANCEDPIPE_DECIMAL_PLACES_VALIDATORS = {
    outerDiameter: { USC: 3, SI: 2 },
    wallThickness: { USC: 3, SI: 2 },
    minWallThickness: { USC: 2, SI: 2 },
    grade: { USC: 0, SI: 0 },
    maxFlawSize: { USC: 5, SI: 5 },
    materialToughness: { USC: 2, SI: 2 },
    ovality: { USC: 2, SI: 2 },
    eccentricity: { USC: 2, SI: 2 },
    poisson: { USC: 2, SI: 2 }, 
    residualStress: { USC: 4, SI: 4 },
    smys: { USC: 1, SI: 1 }, 
    uts: { USC: 1, SI: 1 }, 
    youngModulus: { USC: 0, SI: 0 }, 
    realAxialLoad: { USC: 3, SI: 2 },
    internalPressure: { USC: 2, SI: 3 }, 
    externalPressure: { USC: 2, SI: 3 }
};

// Constante específica para decimales en outputs/resultados
export const ADVANCEDPIPE_RESULT_DECIMAL_PLACES = {
    pipeID: { USC: 3, SI: 2 },           // Diámetro interno
    length: { USC: 3, SI: 2 },           // Longitudes generales
    pressure: { USC: 3, SI: 2 },         // Presiones (ksi/MPa) - sin decimales para resultados
    stress: { USC: 3, SI: 2 },           // Esfuerzos - ratios adimensionales
    weight: { USC: 0, SI: 0 },           // Peso (lb/kg) - sin decimales
    force: { USC: 3, SI: 3 },            // Fuerzas (kips/kN) - sin decimales
    area: { USC: 2, SI: 1 },             // Áreas (in²/mm²)
    moment: { USC: 1, SI: 0 },           // Momentos de inercia (in⁴/mm⁴)
    dimensionless: { USC: 3, SI: 3 },    // Ratios y factores adimensionales
    default: { USC: 2, SI: 2 }           // Valor por defecto
};

// Configuración específica para cada resultado individual
export const ADVANCEDPIPE_SPECIFIC_RESULT_DECIMALS = {
    // API Results
    pBtensionAPI: { USC: 0, SI: 0 },                    // API Pipe Body Tension
    
    // Pipe Properties
    pipeID: { USC: 3, SI: 2 },                         // Pipe ID
    crossSectionArea: { USC: 2, SI: 1 },               // Cross Sectional Area
    moi: { USC: 1, SI: 1 },                            // Moment of Inertia
    dsuT: { USC: 2, SI: 2 },                           // Slenderness Ratio (D/t)
    
    // Other Results
    deltaP: { USC: 3, SI: 2 },                         // Δp = p₀ - p₁
    equivalentCollapsePressure: { USC: 3, SI: 2 },     // Equivalent Collapse Strength (p₀)
    axialStress: { USC: 3, SI: 2 },                    // Axial Stress (Sσ)
    adjusedYieldStrength: { USC: 3, SI: 2 },           // Adjusted Yield Strength (Ypσ)
    
    // Constants
    apIcollConstA: { USC: 3, SI: 3 },                  // A
    apIcollConstB: { USC: 5, SI: 5 },                  // B
    apIcollConstC: { USC: 2, SI: 2 },                  // C
    apIcollConstF: { USC: 5, SI: 5 },                  // F
    apIcollConstG: { USC: 5, SI: 5 },                  // G
    
    // Critical D/t
    dsuTcritYieldColl: { USC: 3, SI: 3 },              // Critical D/t for Yield Collapse
    dsuTcritPlasticColl: { USC: 3, SI: 3 },            // Critical D/t for Plastic Collapse
    dsuTcritTransitionColl: { USC: 3, SI: 3 },         // Critical D/t for Transition Collapse
    effectiveTension: { USC: 3, SI: 3 }                // Effective Tension
};

// Hot Rotary Straightening options
export const ADVANCEDPIPE_HOT_ROTARY_OPTIONS = [
    { label: 'None', value: 'None' },
    { label: 'HRS', value: 'HRS' },
    { label: 'CRS', value: 'CRS' }
];

// Helper function to get max/min values based on unit system
export function getAdvancedPipeMaxMinValidator(key: string, unitSystem: UnitSystem): number {
    const validator = (ADVANCEDPIPE_MAX_MIN_VALIDATORS as any)[key];
    if (validator && typeof validator === 'object' && validator[unitSystem] !== undefined) {
        return validator[unitSystem];
    }
    return validator || 0;
}

export function getAdvancedPipeDecimalPattern(field: string, unitSystem: UnitSystem.USC | UnitSystem.SI = UnitSystem.USC): string {
    // Special case for non-numeric fields
    if (field === 'grade') {
        return "^[a-zA-Z0-9\\s\\-_.()]+$"; // Alphanumeric with spaces, dashes, underscores, dots, parentheses
    }

    let decimals = 2;
    if ((ADVANCEDPIPE_DECIMAL_PLACES_VALIDATORS as any)[field]) {
        decimals = (ADVANCEDPIPE_DECIMAL_PLACES_VALIDATORS as any)[field][unitSystem] ?? 2;
    }

    // Usar la función parametrizada en lugar del switch
    return REGEXP_PATTERNS.DECIMAL_PLACES(decimals);
}